/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sharedplan_UnavailableInputs */

const en_us2_sharedplan_unavailable = /** @type {(inputs: Sharedplan_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connect to the internet to see this plan.`)
};

const pt_br2_sharedplan_unavailable = /** @type {(inputs: Sharedplan_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conecte-se à internet para ver este plano.`)
};

const pt_pt2_sharedplan_unavailable = /** @type {(inputs: Sharedplan_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conecte-se à internet para ver este plano.`)
};

/** @type {(inputs: Sharedplan_UnavailableInputs) => LocalizedString} */
const es_419_sharedplan_unavailable = en_us2_sharedplan_unavailable;

/** @type {(inputs: Sharedplan_UnavailableInputs) => LocalizedString} */
const fr_fr2_sharedplan_unavailable = en_us2_sharedplan_unavailable;

/** @type {(inputs: Sharedplan_UnavailableInputs) => LocalizedString} */
const de_de2_sharedplan_unavailable = en_us2_sharedplan_unavailable;

/** @type {(inputs: Sharedplan_UnavailableInputs) => LocalizedString} */
const it_it2_sharedplan_unavailable = en_us2_sharedplan_unavailable;

/**
* | output |
* | --- |
* | "Connect to the internet to see this plan." |
*
* @param {Sharedplan_UnavailableInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const sharedplan_unavailable = /** @type {((inputs?: Sharedplan_UnavailableInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sharedplan_UnavailableInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_sharedplan_unavailable(inputs)
	if (locale === "es-419") return es_419_sharedplan_unavailable(inputs)
	if (locale === "pt-PT") return pt_pt2_sharedplan_unavailable(inputs)
	if (locale === "fr-FR") return fr_fr2_sharedplan_unavailable(inputs)
	if (locale === "de-DE") return de_de2_sharedplan_unavailable(inputs)
	if (locale === "it-IT") return it_it2_sharedplan_unavailable(inputs)
	return en_us2_sharedplan_unavailable(inputs)
});
export { sharedplan_unavailable as "sharedplan.unavailable" }